'use strict';

var _reactIntl = require('react-intl');

var messages = (0, _reactIntl.defineMessages)({
	POPULAR_SPECIALIST_SEARCHES: {
		'id': 'HOME.POPULAR_SPECIALIST_SEARCHES',
		'defaultMessage': 'Popular Specialist Searches'
	}
});

module.exports = messages;


// WEBPACK FOOTER //
// ./components/popular-specialist-searches/lib/lang/default-messages.js